import React from 'react'
import { Box, Flex, Text } from '@fundamentals'
import {
  TaskTemplatePriorityType,
  TaskTemplateProperties,
} from '@core/entities/task/TaskTemplateProperties'
import capitalize from 'lodash/capitalize'
import moment from 'moment'
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag'
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'
import { User } from '@core/entities/user'

type ComponentProps = {
  templateName: string
  summary: string
  priority: TaskTemplatePriorityType
  user: {
    firstName: string
    lastName: string
  }
  dueDate: string
  location?: string
}

export const TaskSummary: React.FC<ComponentProps> = ({
  templateName,
  summary,
  priority,
  user,
  dueDate,
  location,
}) => {
  const assigneeUser = User.new(user)
  return (
    <Box pt={1}>
      <Text variant='body2' color='textSecondary'>
        {templateName}
      </Text>
      <Text variant='h6' sx={{ mb: 1.5 }}>
        {summary}
      </Text>
      <Flex alignItems='center' mb={0.5} sx={{ color: 'text.secondary' }}>
        <OutlinedFlagIcon fontSize='small' sx={{ mr: 1 }} />
        <Box
          height={16}
          width={16}
          borderRadius='50%'
          sx={{
            backgroundColor:
              TaskTemplateProperties.getColorForPriority(priority),
            mr: 0.5,
          }}
        />
        <Text variant='body2'>{capitalize(priority)}</Text>
      </Flex>
      <Flex alignItems='center' mb={0.5} sx={{ color: 'text.secondary' }}>
        <PersonOutlinedIcon fontSize='small' sx={{ mr: 1 }} />
        <Text variant='body2'>{assigneeUser?.getFullName()}</Text>
      </Flex>
      {!!location && (
        <Flex alignItems='center' mb={0.5} sx={{ color: 'text.secondary' }}>
          <LocationOnOutlinedIcon fontSize='small' sx={{ mr: 1 }} />
          <Text variant='body2'>{location}</Text>
        </Flex>
      )}
      <Flex alignItems='center' sx={{ color: 'text.secondary' }}>
        <EventBusyOutlinedIcon fontSize='small' sx={{ mr: 1 }} />
        <Text variant='body2'>
          {moment(dueDate).format('Do MMM YYYY HH:mm')}
        </Text>
      </Flex>
    </Box>
  )
}
